export interface ICommand { }

export class CreateEnterpriseTemplateFromProjectPlanCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlanTemplates.Commands.CreateEnterpriseTemplateFromProjectPlanCommandV1, TCh.Domain.Quest'

	UserId: number
	WorkspaceId: number
	PortfolioId: string
	ProjectId: string
	ProjectPlanId: string
	Id: string
	StrategyId: string
	Name: string
	Description: string

	constructor (userId: number, workspaceId: number, portfolioId: string, projectId: string, projectPlanId: string, id: string, strategyId: string, name: string, description: string)
	{
		this.UserId = userId
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
		this.ProjectPlanId = projectPlanId
		this.Id = id
		this.StrategyId = strategyId
		this.Name = name
		this.Description = description
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlanTemplates.Commands.CreateEnterpriseTemplateFromProjectPlanCommandV1, TCh.Domain.Quest'
	}

}

export class CreateProjectPlanTemplateCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlanTemplates.Commands.CreateProjectPlanTemplateCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	DurationInMonths: number
	Granularity: any
	Denomination: any

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, durationInMonths: number, granularity: any, denomination: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.DurationInMonths = durationInMonths
		this.Granularity = granularity
		this.Denomination = denomination
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlanTemplates.Commands.CreateProjectPlanTemplateCommandV1, TCh.Domain.Quest'
	}

}

export class DeleteProjectPlanTemplateCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlanTemplates.Commands.DeleteProjectPlanTemplateCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string

	constructor (workspaceId: number, strategyId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlanTemplates.Commands.DeleteProjectPlanTemplateCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectPlanTemplateCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.ProjectPlanTemplates.Commands.UpdateProjectPlanTemplateCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	DurationInMonths: number
	Granularity: any
	Denomination: any

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, durationInMonths: number, granularity: any, denomination: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.DurationInMonths = durationInMonths
		this.Granularity = granularity
		this.Denomination = denomination
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.ProjectPlanTemplates.Commands.UpdateProjectPlanTemplateCommandV1, TCh.Domain.Quest'
	}

}

